/* @jsx h */
import { Layout } from "@app/vue/components/index";
import { AuthProvider } from "@app/vue/providers/index";
import { defineComponent, h, onErrorCaptured, ref } from "vue";

export default defineComponent({
  name: "App",
  setup() {
    const err = ref<null | Error>(null);
    onErrorCaptured((e) => {
      console.log("e", e);
      err.value = e;
    });
    return () => {
      // render reload button so user doesn't have to restart mobile app
      // console.log("err", err.value);
      if (err.value) {
        return (
          <div class="h-screen flex flex-col gap-4 items-center justify-center max-w-md px-6">
            <div class="text-4xl text-center">Uh-oh! Something went wrong!</div>
            <button
              onClick={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
              class="btn btn-primary btn-lg"
            >
              reload
            </button>
          </div>
        );
      }
      return <AuthProvider>{() => <Layout />}</AuthProvider>;
    };
  },
});
